// ** Imports createContext function
import { createContext } from 'react'

// ** Imports createContextualCan function
import { createContextualCan } from '@casl/react'
import type { AnyAbility } from '@casl/ability'

// ** Create Context
export const AbilityContext = createContext<AnyAbility>(undefined!)

// ** Init Can Context
export const Can = createContextualCan(AbilityContext.Consumer)
